import { Pipe, PipeTransform } from '@angular/core';
import { StatusCabecalhoPedidoDeCarga as Status } from '../../models/pedido-de-carga/StatusCabecalhoPedidoDeCarga';

@Pipe({
  name: 'badgeStatusCabecalhoPedidoDeCarga',
})
export class BadgeStatusCabecalhoPedidoDeCargaPipe implements PipeTransform {
  transform(value: Status): string {
    return {
      [Status.Calculado]: 'primary',
      [Status.Verificado]: 'primary',
      [Status.FalhaNaComunicacaoAPI]: 'danger',
      [Status.PedidoComCriticaAPI]: 'danger',
      [Status.PedidoRealizadoAPI]: 'success',
      [Status.PedidoRealizadoArquivoGerado]: 'success',
      [Status.PedidoCancelado]: 'danger',
    }[value];
  }
}
